import { throwError } from 'tg-commons'
import { type PartialTgMapConfig, setTgMapConfig } from 'tg-map-core'
import 'tg-map-core/dist/tg-map-core.css'
import type { App, Component } from 'vue'

import MapMixin, { MIXIN_HOOK_CREATE, MIXIN_HOOK_DESTROY, MIXIN_MAP_NAME } from './map-mixin'

const TgMapPlugin = {
  install(app: App, config?: PartialTgMapConfig) {
    setTgMapConfig(config)
    // Vue3中提倡在需要用的地方导入组件, 对tree-shrink更友好
    if (import.meta.env.VITE_FALSE) {
      // 注册所有Tg开头的Vue
      // ## webpack:
      // const views = require.context('./', true, /Tg.*\.vue$/)
      // ## vite:
      const views = import.meta.glob('./**/Tg*.vue', { eager: true, import: 'default' })
      Object.keys(views).forEach(key => {
        const TgVue = views[key] as Component
        app.component(TgVue.name ?? throwError(`Tg开头的组件必须设置name: ${key}`), TgVue)
      })
    }

    const strategies = app.config.optionMergeStrategies
    // Vue3中必须自己写合并策略: https://github.com/vuejs/core/issues/861
    strategies[MIXIN_HOOK_CREATE] = strategies[MIXIN_HOOK_DESTROY] = (to, from) => {
      // 依照Vue2的风格, 将方法合并成数组
      // 参考:
      // - Vue3兼容模式: https://github.com/vuejs/core/blob/650f5c26f464505d9e865bdb0eafb24350859528/packages/runtime-core/src/componentOptions.ts#L1065
      // - Vue2: https://github.com/vuejs/vue/blob/a9ca2d85193e435e668ba25ace481bfb176b0c6e/src/core/util/options.ts#L154
      return to
        ? [...new Set([].concat(to as any, from as any))]
        : Array.isArray(from)
          ? from
          : [from]
    }
  },
}

/* 导出变量, 外部应该只使用从这里导出的变量 */
export default TgMapPlugin
// 导出map和utils目录
export * from 'tg-map-core'
export { default as LifecycleLogPlugin, type LifecycleLogOptions } from '../utils/lifecycle-log'
export * from '../utils/vue-utils'
// 导出vue文件
export { default as TgCustomControl } from './controls/TgCustomControl.vue'
export { default as TgMapTypeControl } from './controls/TgMapTypeControl.vue'
export { default as TgScaleControl } from './controls/TgScaleControl.vue'
export { default as TgStreetViewControl } from './controls/TgStreetViewControl.vue'
export { default as TgZoomControl } from './controls/TgZoomControl.vue'
export { default as TgHeatmap } from './extra/TgHeatmap.vue'
export { default as TgMarkerClusterer } from './extra/TgMarkerClusterer.vue'
export { default as TgTrafficLayer } from './layers/TgTrafficLayer.vue'
export * from './map-hooks'
export { default as TgCircle } from './overlays/TgCircle.vue'
export { default as TgElementOverlay } from './overlays/TgElementOverlay.vue'
export { default as TgInfoBox } from './overlays/TgInfoBox.vue'
export { default as TgInfoWindow } from './overlays/TgInfoWindow.vue'
export { default as TgLabel } from './overlays/TgLabel.vue'
export { default as TgMarker } from './overlays/TgMarker.vue'
export { default as TgPolygon } from './overlays/TgPolygon.vue'
export { default as TgPolyline } from './overlays/TgPolyline.vue'
export { default as TgRectangle } from './overlays/TgRectangle.vue'
export { default as TgMap } from './TgMap.vue'
export { default as TgMapWidget } from './TgMapWidget.vue'
export {
  MapMixin, MIXIN_HOOK_CREATE,
  MIXIN_HOOK_DESTROY,
  MIXIN_MAP_NAME,
}
// END
